import React from 'react';
import glamorous from 'glamorous';
import { RangeSlider } from '@blueprintjs/core';
import { withStateHandlers } from 'recompose';

import { CHARTS_YEARS_RANGE } from './constants';

const Filters = (props) => {
  const { onRangeSliderRelease, onRangeSliderChange, yearsRange } = props;

  return (
    <glamorous.Div
      css={{
        marginTop: 40,
        marginBottom: 40,
      }}
      className="row"
    >
      <div className="col-md-12">
        <RangeSlider
          onRelease={onRangeSliderRelease}
          onChange={onRangeSliderChange}
          value={yearsRange}
          min={CHARTS_YEARS_RANGE.min}
          max={CHARTS_YEARS_RANGE.max}
        />
      </div>
    </glamorous.Div>

  );
};

const withFiltersState = withStateHandlers((props) => ({ ...props }),
  {
    onRangeSliderRelease: ({ updateDashboardYearsRange }) => (range) => {
      updateDashboardYearsRange(range);
      return { yearsRange: range };
    },
    onRangeSliderChange: () => (range) => ({ yearsRange: range }),
  });

export default withFiltersState(Filters);



// WEBPACK FOOTER //
// ./src/views/dashboard/filters.js